<template>
    <div class="modal fixed bg-white inset-0 w-full h-screen-visible z-[41] flex flex-col cursor-default text-black">
        <div class="border-b">
            <div class="flex items-center relativ h-14 container">
                <Btn
                    variant="text"
                    size="xxs"
                    :icon="closeIcon"
                    @click.stop="close()"
                />
                <h4 class="font-body-1-medium ml-4 mr-2 flex-grow truncate">{{ title }}</h4>
                <slot name="cta">
                    <BtnCta
                        v-if="ctaText"
                        variant="tertiary"
                        :label="ctaText"
                        @click.stop="$emit('cta')"
                    />
                </slot>
            </div>
        </div>

        <div :class="['flex flex-col flex-1 overflow-y-auto whitespace-normal', { 'bg-slate-50': !white }]">
            <slot />
        </div>

        <div :class="['flex', { 'bg-slate-50': !white }]">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import ModalMixin from '@mixins/modalMixin';
import { mapGetters } from 'vuex';

const CLOSE_STYLE = {
    BACK: 'back',
    CLOSE: 'close',
};

/**
 * This modal layout spans the whole screens and emits a close event when the screen size changes.
 * Ideal for small screen overlays.
 *
 * @emits close
 * @emits cta
 */
export default {
    name: 'ModalFullscreen',
    extends: ModalMixin,
    props: {
        title: {
            type: String,
            required: true,
        },
        ctaText: {
            type: String,
            default: undefined,
        },
        closeStyle: {
            type: String,
            default: CLOSE_STYLE.BACK,
        },
        /* DEPRECATED, only here for "old modal" support */
        white: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cta'],
    computed: {
        ...mapGetters('ui', ['screenSize']),
        closeIcon() {
            return this.closeStyle === CLOSE_STYLE.CLOSE ? 'close' : 'chevron-left';
        },
    },
    watch: {
        screenSize(val) {
            if (val !== 'small') this.close();
        },
    },
};
</script>
